import React from 'react';
import clsx from 'clsx';

interface RollingDigitProps {
  value: number;
}

const RollingDigit: React.FC<RollingDigitProps> = ({ value }) => {
  return (
    <div className="relative h-[1em] w-[0.65em] overflow-hidden inline-block align-bottom">
      <div
        className="transition-transform duration-700 absolute left-0 top-0 flex flex-col items-center w-full"
        style={{ 
          transform: `translateY(-${value * 10}%)`,
          transitionTimingFunction: 'cubic-bezier(0.34, 1.56, 0.64, 1)'
        }}
      >
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
          <div key={num} className="h-[1em] w-full flex items-center justify-center">
            {num}
          </div>
        ))}
      </div>
    </div>
  );
};

interface RollingPriceProps {
  price: number;
  className?: string;
}

const RollingPrice: React.FC<RollingPriceProps> = ({ price, className }) => {
  const safePrice = Math.round(Number(price) || 0);
  const digits = safePrice.toString().split('').map(Number);

  return (
    <div className={clsx("inline-flex items-center overflow-hidden h-[1em] leading-none tabular-nums", className)}>
      {digits.map((digit, index) => (
        <RollingDigit key={`${index}-${digits.length}`} value={digit} />
      ))}
    </div>
  );
};

export default RollingPrice;
